import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../app/RootReducer";
import { GetCurrentLocale } from "../../components/Utils";
import { URL_FOR_RESOURCES } from "../../app/AppConfig";
import ButtonsQuantityMultiple from "../../components/ButtonsQuantityMultiple";
import { SpinnerOnTop } from "../../components/SpinnerOnTop";
import t from "../../components/I18N/TranslateHelpers";
import {
  buttonForWishlist,
  getVariantOfProduct,
  productExistsInWishlist,
  removeItemFromCartButton,
  removeItemFromCartOffer,
} from "../../components/UtilsForCart";
import {
  getProductIdFromItem,
  shouldHidePriceForProduct
} from "../../components/Catalogue/userCatalogUtils";
import ProductPrice from "./ProductPrice/ProductPrice";


interface ComponentProps {
  productItem: any;
  isForCart: boolean;
  isItemForRequestOffer: boolean;
  tokenValue: string;
  isRequestingAdd: any;
  dispatch?: any;
}

const HtmlForItemProduct: React.FC<ComponentProps> = ({
                                                        productItem,
                                                        isForCart,
                                                        isItemForRequestOffer,
                                                        tokenValue,
                                                        isRequestingAdd,
                                                        dispatch,
                                                      }) => {
  const [isInWishlist, setIsInWishlist] = useState(false);
  const [productIdRequest, setProductIdRequest] = useState(0);

  const locale = GetCurrentLocale();
  const isAuthenticated = useSelector((state: RootState) => state.userRdc.isAuthenticated);
  const userAccount = useSelector((state:RootState) => state.userRdc.userDetail?.customer)
  const userCatalogs = useSelector((state: RootState) => state.userRdc.userCatalog);

  const productId = getProductIdFromItem(productItem, isItemForRequestOffer);
  const hidePrice = shouldHidePriceForProduct(productId, userCatalogs);

  useEffect(() => {
    if (userAccount && productItem) {
      const id = getProductIdFromItem(productItem, isItemForRequestOffer);
      if (productExistsInWishlist(id, userAccount.favouriteProducts)) {
        setIsInWishlist(true);
      }
    }
  }, [userAccount, productItem]);

  return (
    <article className="row gy-3 mb-4 align-items-center" key={productItem.id + "-" + productItem.name}>
      <div className="col-lg-6">
        <figure className="itemside me-lg-5">
          <div className="aside">
            <img
              src={
                URL_FOR_RESOURCES + "/media/image/" + (isItemForRequestOffer ? productItem.variant.product.imageUrl : productItem.product.imageUrl)
              }
              className="img-sm img-thumbnail"
              alt={productItem.product?.name ?? ""}
            />
            {
              productItem.commercialUnit > 1 ?
              <span className="alert alert-warning d-flex flex-column p-1 mb-0 mt-2">
                  <span className="fs-4">
                  <i className="fa-solid fa-triangle-exclamation me-1"></i>
                  Ce produit est vendu par {productItem.commercialUnit}
                  </span>
                  <small className="fs-10">
                  Si vous prenez 2 quantités, vous en recevrez donc {productItem.commercialUnit * 2}
              </small>
            </span>
            : null
            }

          </div>
          <figcaption className="info info-product-in-cart">
            <a
              href={`/${locale}${t("url_detail_product")}/${isItemForRequestOffer ? productItem.variant.product.slug : productItem.product.slug}`}
              className="h6 d-flex"
            >
              {isItemForRequestOffer ? productItem.variant.product.name : productItem.product.name}
            </a>
            <span className="price-old">{productItem.reference}</span>
          </figcaption>
          <div className="aside maxwidth50">
            <p
              dangerouslySetInnerHTML={{
                __html: isItemForRequestOffer ? productItem.variant.description : productItem.product.description,
              }}
            />
          </div>
        </figure>
      </div>

      <div className="col-lg-2 col-sm-5">
        <div className={isItemForRequestOffer ? "variants in-cart" : "variants"}>
          {isForCart && getVariantOfProduct(productItem)}
          <ButtonsQuantityMultiple
            quantityInCart={productItem.quantity}
            variantCode={isItemForRequestOffer ? productItem.variant.code : productItem.variantCode}
            tokenValue={tokenValue}
            dispatch={dispatch}
            isCartQuantity={isForCart}
            itemOrderId={productItem.id}
          />
        </div>
      </div>

      <div className="col-lg-2 text-center col-sm-4">
        {isForCart ? (
          <ProductPrice
            productItem={{
              ...productItem,
              id: productId,
            }}
            mode="cart"
            quantity={productItem.quantity}
          />
        ) : (
          <div className="variants">{getVariantOfProduct(productItem)}</div>
        )}
      </div>

      <div className="col-lg-2 col-sm-3">
        <div className="float-lg-end d-flex">
          {isRequestingAdd && productId === productIdRequest ? (
            <div className="px-4 d-flex align-items-center">
              <SpinnerOnTop />
            </div>
          ) : (
            isAuthenticated &&
            buttonForWishlist(
              !isInWishlist,
              dispatch,
              productId,
              setIsInWishlist,
              setProductIdRequest
            )
          )}

          <button
            className="btn btn-danger text-danger"
            title={t("delete_product")}
            onClick={() =>
              isItemForRequestOffer
                ? removeItemFromCartOffer(productItem.variant.code, tokenValue, dispatch)
                : removeItemFromCartButton(dispatch, productItem.id)
            }
          >
            <i className="fa-solid fa-xmark"></i>
          </button>
        </div>
      </div>
    </article>
  );
};

export default HtmlForItemProduct;
